export enum Signals {
    PlayerSpawn = 'player_spawn',
    PlayerDeath = 'player_death',
    PlayerRestSpotStatusChange = 'player_upgrade_status_change',
    Pause = 'pause',
    Resume = 'resume',
    UpgradePlayer = 'upgrade_player',
    MenuInitialized = 'menu_init',
    CloseMenu = 'close_menu',
    RoomConstruct = 'room_construct',
    RoomStart = 'room_start',
    BossRoomStart = 'boss_room_start',
    AllEnemiesDefeated = 'all_enemies_defeated',
    RoomComplete = 'room_complete',
    RoomDestroy = 'room_destroy',
    DungeonConstruct = 'dungeon_construct',
    DungeonComplete = 'dungeon_complete',
    NewChatMessage = 'new_chat_message',
    ToggleSound = 'toggle_sound',
    NewWorld = 'new_world',
}